module.exports = {
	"OceanDragon": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "กรุณาคลิกที่ลิงค์เพื่อรับเพ็ท Legendary และคริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "มอบคริสตัลเป็นของขวัญให้กับผู้เล่นใหม่และผู้เล่น inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1,000 อัน + มังกรพายุหมุน",
		"mission": "<strong>MISSION!</strong> วิ่งในโหมดเบรคเอาท์ Episode 1 จนถึงสเตจ 1-5!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"2ndAnniversary": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "กรุณาคลิกที่ลิงค์เพื่อรับเพ็ท Legendary และคริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "มอบคริสตัลเป็นของขวัญให้กับผู้เล่นใหม่และผู้เล่น inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ : คริสตัล 2,222 อัน + มังกรพายุหมุน",
		"mission": "<strong>MISSION!</strong> วิ่งในโหมดเบรคเอาท์ Episode 1 จนถึงสเตจ 1-5!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"MoonLight": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงค์เพื่อรับคุกกี้ Legendary และคริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "มอบคริสตัลเป็นของขวัญให้กับผู้เล่นใหม่และผู้เล่น inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1,000 อัน + คุกกี้แสงจันทร์",
		"mission": "<strong>MISSION!</strong> วิ่งในโหมดเบรคเอาท์ Episode 1 จนถึงสเตจ 1-5!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"FireSpirit": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงค์เพื่อรับคุกกี้ Legendary และคริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "มอบคริสตัลเป็นของขวัญให้กับผู้เล่นใหม่และผู้เล่น inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1 พันอัน + คุกกี้ภูติอัคคี",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"RainbowCube": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะลิงค์เพื่อนรับคริสตัลและลูกบาศก์สายรุ้ง!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "มอบคริสตัลเป็นของขวัญให้กับผู้เล่นใหม่และผู้เล่น inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ : คริสตัล 3,000 อัน + ลูกบากศ์สายรุ้ง 1,000 อัน",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"JellySkin": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะลิงค์เพื่อนรับคริสตัลและลูกบาศก์สายรุ้ง!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "รับลูกบาศก์สายรุ้งและคริสตัลไปเลยทั้งผู้เล่นใหม่และผู้เล่น Inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ : คริสตัล 3,000 อัน + ลูกบากศ์สายรุ้ง 1,000 อัน",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"Yeti": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงก์เพื่อรับเพ็ท Legendary & คริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "รับไปเลยเพ็ท Legendary & คริสตัลสำหรับผู้เล่นใหม่/Inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ : คริสตัล 1,000 อัน + เยติพายุหิมะ",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"DreamCatcher": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงก์เพื่อรับเพ็ท Legendary & คริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "รับไปเลยเพ็ท Legendary & คริสตัลสำหรับผู้เล่นใหม่/Inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1,000 อัน + ดรีมแคตเชอร์แสงดาว",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"WaveDrop": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงก์เพื่อรับเพ็ท Legendary & คริสตัล!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "รับไปเลยเพ็ท Legendary & คริสตัลสำหรับผู้เล่นใหม่/Inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1,000 อัน + หยดคลื่น",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	},
	"JellySkin02": {
		"title": "คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"description": "แตะที่ลิงก์แล้วรับคริสตัล & โดนัทอวกาศไปเลย!",
		"gift": "มาแล้ว ของขวัญจาก",
		"gift_no_name": "รับไปเลยโดนัทอวกาศ & มินิบอลอวกาศ<br />และคริสตัลสำหรับผู้เล่นใหม่/Inactive!",
		"download_now": "หากคุณยังไม่ดาวน์โหลดเกมคุกกี้รัน: ศึกคุกกี้หนีเตาอบ<br>ดาวน์โหลดเลยตอนนี้!",
		"how_to_get_reward": "วิธีรับของขวัญ",
		"install_cro": "ติดตั้ง คุกกี้รัน: ศึกคุกกี้หนีเตาอบ",
		"claim_reward": "แตะปุ่มรับของขวัญ",
		"rewards": "* ของขวัญ: คริสตัล 1,000 อัน + โดนัทอวกาศ & เพ็ท X20",
		"mission": "<strong>มิชชั่น!</strong> เข้าโหมดแข่งชิงถ้วย!",
		"condition": "ของขวัญสำหรับผู้เล่นใหม่ / Inactive เท่านั้น",
		"new_player": "*ผู้เล่นใหม่ คือ? ผู้เล่นที่เข้าเล่นเกมคุกกี้รันเป็นครั้งแรกในช่วงเวลากิจกรรม",
		"old_player": "* ผู้เล่นที่กลับมา คือ? ผู้เล่นที่ไม่ได้เข้าเล่นเกมเป็นเวลา 30 วัน ขึ้นไปแล้วกลับมาเล่นเกมอีกครั้ง"
	}
};